
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1607047840799",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4809",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M410.112 513.664 97.664 513.664c-17.664 0-32 14.336-32 32s14.336 32 32 32l242.752 0-267.456 267.456c-12.032 12.032-12.032 31.36 0 43.392 11.968 11.968 31.36 11.968 43.328 0l269.376-269.376 0 246.592c0 17.664 14.336 32 32 32s32-14.336 32-32l0-320C449.664 521.6 435.84 513.664 410.112 513.664zM553.216 449.664l312.512 0c17.664 0 32-14.336 32-32s-14.336-32-32-32L622.912 385.664l267.456-267.456c12.032-12.032 12.032-31.36 0-43.392-11.968-11.968-31.36-11.968-43.328 0L577.664 344.256 577.664 97.664c0-17.664-14.336-32-32-32s-32 14.336-32 32l0 320C513.664 438.144 529.664 449.664 553.216 449.664z",
        "p-id": "4810"
      }
    }
  ]
})
    }
  